<template>
    <LayoutSidebar v-model:isOpen="isSidebarOpen">
        <template #sidebar>
            <PanelSidebar :navigation="navItems" />
        </template>
        <template #logo>
            <ButtonSecondaryIconSm @click="goToDashboard">
                <ArrowLeftIcon />
            </ButtonSecondaryIconSm>
        </template>
        <template #header>
            <PanelHeader :title="currentHeader" :beforeTitle="player.name" />
        </template>
        <template #main>
            <template v-if="player?.ecProductIds?.length > 0">
                <router-view />
            </template>
            <CardEmpty
                v-else
                class="mt-6 w-full"
                :title="$t('player.panel.connect_with_ec')"
                :subtitle="$t('player.panel.connect_with_ec_info')"
                :icon="emptyIcon"
                :ctaLabel="$t('player.panel.connect_with_ec_button')"
                @add="goToProject"
            />
        </template>
    </LayoutSidebar>
</template>

<script>
import { markRaw } from "vue";
import { mapState, mapGetters, mapActions } from "vuex";
import { LayoutSidebar } from "@easy/ui/layouts";
import {
    UsersIcon,
    PageIcon,
    MultipleFileIcon,
    ArrowLeftIcon,
    ShippingBoxIcon,
} from "@easy/ui/icons";
import { CardEmpty } from "@easy/ui/cards";
import { ButtonSecondaryIconSm } from "@easy/ui/buttons";
import PanelHeader from "../panel/PanelHeader.vue";
import PanelSidebar from "../panel/PanelSidebar.vue";
import { PLAYER_ROUTE_NAMES } from "@/apps/player/player.routes";
import { userService } from "@/shared/user/user.service";

export default {
    components: {
        LayoutSidebar,
        PanelHeader,
        PanelSidebar,
        ButtonSecondaryIconSm,
        ArrowLeftIcon,
        CardEmpty,
    },
    data() {
        return {
            isSidebarOpen: false,
        };
    },
    computed: {
        ...mapState("player", ["player"]),
        ...mapGetters(["userId", "activeAppDashboardLink"]),
        currentHeader() {
            const currentNavItem = this.navItems.find((item) => item.name === this.$route.name);
            return currentNavItem?.label;
        },
        emptyIcon() {
            return markRaw(ShippingBoxIcon);
        },
        navItems() {
            return [
                {
                    label: this.$t("player.panel.users.title"),
                    icon: markRaw(UsersIcon),
                    name: PLAYER_ROUTE_NAMES.panelUsers,
                    handler: () => this.$router.push({ name: PLAYER_ROUTE_NAMES.panelUsers }),
                },
                {
                    label: this.$t("player.panel.certificates.title"),
                    icon: markRaw(PageIcon),
                    name: PLAYER_ROUTE_NAMES.panelCertificates,
                    handler: () =>
                        this.$router.push({ name: PLAYER_ROUTE_NAMES.panelCertificates }),
                },
                {
                    label: this.$t("player.panel.lessons.title"),
                    icon: markRaw(MultipleFileIcon),
                    name: PLAYER_ROUTE_NAMES.panelLessons,
                    handler: () => this.$router.push({ name: PLAYER_ROUTE_NAMES.panelLessons }),
                },
            ];
        },
    },
    mounted() {
        this.$watch(() => this.$route.params.projectUuid, this.handleProjectChange, {
            immediate: true,
        });
    },
    methods: {
        ...mapActions("player/projects", ["loadProject"]),
        handleProjectChange(uuid, oldUuid) {
            if (uuid && uuid !== oldUuid) {
                this.loadProject(uuid);
            }
        },
        async goToDashboard() {
            const { magicUrl } = await userService.forgeMagicLink(this.activeAppDashboardLink);
            window.location = magicUrl;
        },
        goToProject() {
            this.$router.push({ name: PLAYER_ROUTE_NAMES.projectPaywall });
        },
    },
};
</script>
